export const validation = {

    text: {
        min: 2,
        max: 140
    },
    email: {
        min: 2,
        max: 140,
        regex: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    },
    password: {
        min: 8,
        max: 140
    }

}

export const validateInput = ( type, input, label, options ) => {

    // Options can have
    // min, max, regex, match attributes

    let isValid = false
    let error = null

    if ( input ) {

        // Check regex

        if ( ( options?.regex ? !input.match(options.regex) : null ) || validation[type]?.regex ? !input.match( validation[type].regex ) : null ) {

            error = `${label} is invalid.`

        }

        // Check Min Length

        else if ( input.length < ( options ? options.min ? options.min : validation[type].min : validation[type].min ) ) {

            error = `${label} must be longer than ${ options ? options.min ? options.min : validation[type].min : validation[type].min } letters.`

        }

        // Check Max Length

        else if ( input.length > ( options ? options.max ? options.max : validation[type].max : validation[type].max ) ) {

            error = `${label} can't be longer than ${ options ? options.min ? options.min : validation[type].min : validation[type].min } letters.`

        }

        else {

            isValid = true
            error = null

        }

        return {
            isValid,
            error
        }

    }

}